
export class Moneda {

    idPais: string;
    id: string;
    descripcion: string;
    codigo: number;
    habilitacion: boolean;
}
